__webpack_require__.p = "/switch/";